module.exports = __webpack_public_path__ + "img/lightbulb.3968fd40.svg";